import { render, staticRenderFns } from "./EmailJobs.vue?vue&type=template&id=68b79d81&scoped=true&"
import script from "./EmailJobs.vue?vue&type=script&lang=js&"
export * from "./EmailJobs.vue?vue&type=script&lang=js&"
import style0 from "./EmailJobs.vue?vue&type=style&index=0&id=68b79d81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b79d81",
  null
  
)

/* custom blocks */
import block0 from "./EmailJobs.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VCard,VDataTable,VIcon,VProgressLinear})
